import { useEffect } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const useThemeStore = create()(persist((set, get) => ({
    theme: 'light',
    setTheme: (theme) => set({ theme }),
    toggleTheme: () => set({ theme: get().theme === 'light' ? 'dark' : 'light' }),
}), {
    name: 'assertoor-theme',
}));
export function useTheme() {
    const { theme, setTheme, toggleTheme } = useThemeStore();
    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        }
        else {
            root.classList.remove('dark');
        }
    }, [theme]);
    // Initialize theme from system preference if not set
    useEffect(() => {
        const stored = localStorage.getItem('assertoor-theme');
        if (!stored) {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            setTheme(prefersDark ? 'dark' : 'light');
        }
    }, [setTheme]);
    return { theme, setTheme, toggleTheme };
}
